var SENTRY_RELEASE;SENTRY_RELEASE={name: "Mesa", version: "1.96.0"};